import { mutationUpdateAgreedTour } from "./mutations/mutationUpdateAgreedTour"
import { queryAdmWeekTours } from "./queries/queryAdmWeekTours"
import { typeTourPlanning } from "./tourPlanning"

const tourPlanningSchema = {
  types: [typeTourPlanning],
  resolvers: {
    Query: { ...queryAdmWeekTours },
    Mutation: { ...mutationUpdateAgreedTour },
  },
}

export default tourPlanningSchema
